import STORAGE from './storage';

const queryParams = new URLSearchParams(window.location.search);

export const getFromStorageOrQueryParams = (key: 'AUTH_TOKEN') =>
  STORAGE.read({ key }) ?? queryParams.get(key);
